window.callbackFunc = (res) => {
  if (res?.resultCode === '0000' && res?.resultMessage === 'OK') {
    console.debug('성공: ', res)
  } else {
    console.warn('실패: ', res?.resultMessage || 'Unknown error')
  }
}

export const openOutlink = (url) => {
  if (!url) return

  const datas = {
    url,
    common: {
      callback: 'callbackFunc'
    }
  }

  try {
    if (window.webkit?.messageHandlers?.openNewWindow) {
      // iOS 브릿지
      window.webkit.messageHandlers.openNewWindow.postMessage(JSON.stringify(datas))
    } else if (window.kbpayBridge?.openNewWindow) {
      // Android 브릿지
      window.kbpayBridge.openNewWindow(JSON.stringify(datas))
    } else {
      // 브릿지가 없는 환경
      console.warn('브릿지 없음')
      window.open(url, '_blank')
    }
  } catch (e) {
    console.error('브릿지 에러: ', e)
    window.open(url, '_blank')
  }
}
